import { haveFilterQuery, paginator, haveSort } from '../common/auxFun'

const endpointsOwnCenters = {
  LOAD: (filter, sort, limit, skip) =>
    `/v1/centers${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
  CREATE: `/v1/centers/own`,
  PROVINCES: `/v1/centers/own/provinces`,
  BY_ID: (id) => `/v1/centers/own/${id}`,
  DATA: (id) => `/v1/centers/own/${id}/data`,
  SERVICES: (id) => `/v1/centers/own/${id}/services`,
  EMPLOYEES: (id, filter, sort, limit, skip) =>
    `/v1/centers/own/${id}/users${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
  TECHNICAL: (id) => `/v1/centers/own/${id}/technicalData`,
  COURTS: {
    LOAD: (id, filter, sort, limit, skip) =>
      `/v1/centers/own/${id}/technicalData/tracks/${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
    COURT: (id) => `/v1/centers/own/${id}/technicalData/tracks`,
    BY_ID: (centerId, id) =>
      `/v1/centers/own/${centerId}/technicalData/tracks/${id}`,
  },
  VACUUM_CLEANERS: {
    LOAD: (centerId, filter, sort, limit, skip) =>
      `/v1/centers/own/${centerId}/technicalData/vacuumCleaners${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
    VACUUM_CLEANER: (id) =>
      `/v1/centers/own/${id}/technicalData/vacuumCleaners/`,
    BY_ID: (centerId, id) =>
      `/v1/centers/own/${centerId}/technicalData/vacuumCleaners/${id}`,
  },
  OTHER_DATA: {
    LOAD: (id, filter, sort, limit, skip) =>
      `/v1/centers/own/${id}/technicalData/otherData${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
    OTHER_DATA: (id) => `/v1/centers/own/${id}/technicalData/otherData`,
    BY_ID: (centerId, id) =>
      `/v1/centers/own/${centerId}/technicalData/otherData/${id}`,
  },
  MANUALS: {
    BY_CENTER: (id) => `/v1/centers/own/${id}/manuals`,
    LOAD: (id, filter, sort, limit, skip) =>
      `/v1/centers/own/${id}/manuals${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
    BY_ID: (centerId, id) => `/v1/centers/own/${centerId}/manuals/${id}`,
    UPLOAD: (centerId, id) =>
      `/v1/centers/own/${centerId}/manuals/${id}/upload`,
  },
  EXTERNAL_COMPANIES: {
    LOAD: (id, filter, sort, limit, skip) =>
      `/v1/centers/own/${id}/externalcompanies${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
    BY_CENTER: (id) => `/v1/centers/own/${id}/externalcompanies`,
    BY_ID: (centerId, id) =>
      `/v1/centers/own/${centerId}/externalcompanies/${id}`,
  },
}

export default endpointsOwnCenters
